import $axios from "@/plugins/axios";
const report = {
    getReportList: params => $axios.post('PC/Report/GetReportList', params),
    getReport: params => $axios.post3('PC/Report/GetReport', params),

}
export default report;